import { render } from "./LoginOIDC.vue?vue&type=template&id=3fbf908e&scoped=true"
import script from "./LoginOIDC.vue?vue&type=script&lang=js"
export * from "./LoginOIDC.vue?vue&type=script&lang=js"

import "./LoginOIDC.vue?vue&type=style&index=0&id=3fbf908e&scoped=true&lang=css"

import exportComponent from "/home/gp/git/git.glitchedpolygons.ch/locales.glitchedpolygons.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fbf908e"]])

export default __exports__